import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from "rxjs";

@Injectable()
export class OptionOpenService {

  #focus = new Subject<void>();
  focus$ = this.#focus.pipe();

  #opened = new BehaviorSubject<boolean>(false);
  opened$ = this.#opened.pipe();

  #focusListbox = new Subject<void>();
  focusListbox$ = this.#focusListbox.pipe();

  focusSelect(): void {
    this.#focus.next();
  }

  focusListbox(): void {
    this.#focusListbox.next();
  }

  isOpened(): boolean {
    return this.#opened.value;
  }

  setOpened(value: boolean) {
    this.#opened.next(value);
  }
}
